import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, TemplateRef, DoCheck } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroupDirective, NgForm, NgControl } from '@angular/forms';
import { uuid, getValueByKey, isNullOrEmpty } from '@awp/core/utils';
import { ErrorStateMatcher, mixinErrorState } from '@angular/material/core';
var OptionSelectBase = /** @class */ (function () {
    function OptionSelectBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        this.ngControl = ngControl;
    }
    return OptionSelectBase;
}());
var _OptionSelectMixinBase = mixinErrorState(OptionSelectBase);
var OptionSelectComponent = /** @class */ (function (_super) {
    tslib_1.__extends(OptionSelectComponent, _super);
    function OptionSelectComponent(changeDetectorRef, defaultErrorStateMatcher, _parentFormGroup, _parentForm) {
        var _this = _super.call(this, defaultErrorStateMatcher, _parentForm, _parentFormGroup) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.defaultErrorStateMatcher = defaultErrorStateMatcher;
        _this._parentFormGroup = _parentFormGroup;
        _this._parentForm = _parentForm;
        _this.selectOption = 'button-toggle';
        _this.options = [];
        _this.disabled = false;
        _this.isRequired = false;
        _this.changed = new EventEmitter();
        //#region ControlValueAccessor
        _this._onTouched = function () { };
        _this._onChange = function (value) { };
        _this.groupName = uuid();
        _this.errorStateMatcher = _this;
        return _this;
    }
    OptionSelectComponent.prototype.isErrorState = function (control, form) {
        if (control == null && form && this.formControlName && form.control.get(this.formControlName)) {
            this.errorState = form.submitted && form.control.get(this.formControlName).invalid;
            return this.errorState;
        }
        return this.defaultErrorStateMatcher.isErrorState(control, form);
    };
    OptionSelectComponent.prototype.ngOnInit = function () { };
    OptionSelectComponent.prototype.ngDoCheck = function () {
        this.updateErrorState();
    };
    OptionSelectComponent.prototype.ngOnDestroy = function () { };
    OptionSelectComponent.prototype.ngOnChanges = function (changes) {
        if (changes != null && changes.value != null) {
            this.writeValue(changes.value.currentValue);
        }
    };
    OptionSelectComponent.prototype.onChange = function (value) {
        var _this = this;
        this.value = value;
        if (!isNullOrEmpty(this.fieldValue)
            && (this.selectOption === 'dropdown' || this.selectOption === 'radio')) {
            value = this.options.find(function (p) { return getValueByKey(p, _this.fieldValue) === value; });
        }
        this._onChange(value);
        this.changed.emit(value);
        this._onTouched();
    };
    OptionSelectComponent.prototype.writeValue = function (value) {
        this.value = value;
        this.changeDetectorRef.markForCheck();
    };
    OptionSelectComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    OptionSelectComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    OptionSelectComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return OptionSelectComponent;
}(_OptionSelectMixinBase));
export { OptionSelectComponent };
